import { IconWrapper } from '../runtime';
export default IconWrapper('mention', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M14.9998 12.2499C14.2498 12.9999 12.3997 14.9999 7.99974 14.9999C2.49974 14.9999 0.622489 10.5178 0.999685 7.49988C1.49963 3.49988 4.49976 0.999878 8.49976 0.999878C12.9997 0.999878 14.7498 3.99988 14.7498 6.99988C14.7497 10.5354 11.9997 11.7499 10.9997 11.7499C9.99969 11.7499 9.99969 10.9999 9.99969 9.99988C9.99969 9.19988 10.7498 6.24988 11.2498 4.74988M10.7497 6.24988C10.7497 5.74988 10.0997 4.24988 8.49974 4.24988C6.49974 4.24988 5.13321 6.46596 4.74969 7.99988C4.24964 9.99988 5.24971 11.7499 6.74971 11.7499C8.74971 11.7499 9.49965 10.4999 9.99971 9.49988",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});